export enum LOCALE {
  EN = 'en',
  ES = 'es',
  PT = 'pt',
  DE = 'de',
  TR = 'tr',
  JP = 'jp',
  IT = 'it',
  FR = 'fr',
  RU = 'ru',
  KR = 'kr',
}

export const I18N_LOCALE = Object.values(LOCALE)

export const LocalePath = I18N_LOCALE.reduce((result: string[], locale) => {
  result.push(`/${locale}/`)
  return result
}, [])

export const LOCALE_CODE_MAP = new Map([
  [LOCALE.EN, 'en-US'],
  [LOCALE.JP, 'ja-JP'],
])

export const HTML_LANG_MAP = new Map<LOCALE, string>([
  [LOCALE.JP, 'ja'],
  [LOCALE.KR, 'ko'],
])

export const getHtmlLang = (locale: LOCALE | string = LOCALE.EN) => {
  return HTML_LANG_MAP.get(locale as LOCALE) ?? locale
}
